import { render, staticRenderFns } from "./CandidateEntry.vue?vue&type=template&id=a8a05274&scoped=true"
import script from "./CandidateEntry.vue?vue&type=script&lang=js"
export * from "./CandidateEntry.vue?vue&type=script&lang=js"
import style0 from "./CandidateEntry.vue?vue&type=style&index=0&id=a8a05274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a05274",
  null
  
)

export default component.exports